<template>
  <div class="container">
    <common-bg-image
      content="查看成绩"
      :informationObj="informationObj"
      :scoreObj="scoreObj"
    ></common-bg-image>
    <div class="card-scroll">
      <common-information-card
        class="cards"
        :name="name"
        :informationList="informationList"
      ></common-information-card>
      <div
        :class="{ buttonAdd: classAdd }"
        class="button-container"
        v-if="
          informationObj.bgImageStatus !== 'no' &&
          (isBeike || informationObj.bgImageStatus !== 'invalid')
        "
      >
        <div
          v-for="item in productList"
          :key="item.id"
          @click="productClick(item.id, item.prodCode)"
          class="question-detail"
        >
          {{ item.prodName }}
        </div>
      </div>
    </div>
    <div
      v-if="
        informationObj.bgImageStatus !== 'no' &&
        informationObj.bgImageStatus !== 'invalid'
      "
      v-show="!isBeike"
      class="bottom"
    >
      成绩复核报告{{ productList[0]?.price === 0 ? "申请" : "购买" }}时间{{
        detailOpenTime
      }}。若您对成绩有疑问，请与报名网站客服联系。
    </div>

    <div v-else v-show="!isBeike" class="bottom">
      若您对成绩有疑问，请与报名网站客服联系
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import CommonBgImage from "../../components/commonBgImage.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { replaceTime, getDate } from "../../js/current";
import {
  getSubjectScore,
  getProductList,
  scoreDetailVisited,
} from "../../api/index";
import CommonInformationCard from "../../components/commonInformationCard.vue";
import { onMounted, ref, computed, onBeforeUnmount } from "vue";

export default {
  components: { CommonBgImage, CommonInformationCard },
  name: "ViewResults",
  setup() {
    // 定义router
    const router = useRouter();
    // 定义store
    const store = useStore();
    // 当苹果高度过小调整样式
    let classAdd = ref(false);
    const bodyHeight = document.body.clientHeight;
    if (bodyHeight < 600) {
      classAdd.value = true;
    }

    // card中的列表
    const informationList = ref([
      {
        key: "性别",
      },
      // {
      //   key: "证件号",
      // },
      {
        key: "准考证号",
      },
    ]);
    // card定义考生姓名
    const name = ref("");
    // 定义合格状态去判断背景颜色和显示文字
    const bgImageStatus = ref("");
    // 定义一个查看成绩上半部分信息对象
    let informationObj = ref({});
    // 定义底部满分和题数的对象
    let scoreObj = ref({});
    const toast = ref(null);

    // 有关成绩考生的全部信息
    const getSubjectAllScore = async () => {
      try {
        const {
          data: {
            credentialsID,
            perm,
            sex,
            status,
            candidateName,
            grade,
            examTime,
            subjectName,
          },
        } = await getSubjectScore(store.state.batchCode, store.state.perm);
        informationList.value[0].value = sex;
        // informationList.value[1].value = credentialsID;
        informationList.value[1].value = perm;
        name.value = candidateName;
        if (status === -2) {
          bgImageStatus.value = "invalid";
        } else if (status === -1) {
          toast.value = Toast.fail({
            message: "您可能未参加该科目的考试，因此该科目的成绩无法查询。",
            duration: 60000,
            className: "large-toast-mobile",
          });
          bgImageStatus.value = "no";
        } else if (status === 0) {
          bgImageStatus.value = "unsuccess";
        } else {
          bgImageStatus.value = "success";
        }
        informationObj.value = {
          grade,
          subjectName,
          bgImageStatus: bgImageStatus,
          examTime: getDate(examTime),
        };
      } catch (error) {
        console.log(error);
      }
    };
    // 定义查看成绩页面成绩复核报告开放时间
    let detailOpenTime = ref("");
    // 获取商品列表数据从中拿时间数据
    const productList = ref([]);
    const getProductsList = async () => {
      try {
        const { data } = await getProductList(store.state.batchCode);
        productList.value = data.filter((item) => {
          if (item.prodName === "答题明细") {
            item.prodName = "成绩复核报告";
          }
          return item.available && item.prodName !== "诊断报告";
        });
        const { beginTime, endTime } = data[0];
        // 把商品列表对象保存到store中
        store.commit("saveProductObj", data[0]);
        detailOpenTime.value = `${replaceTime(beginTime)} - ${replaceTime(
          endTime
        )}`;
      } catch (error) {
        console.log(error);
      }
    };

    // 跳转成绩复核报告
    const productClick = async (id, prodCode) => {
      // const { data, message } = await scoreDetailVisited(
      //   store.state.batchCode,
      //   store.state.perm,
      //   id
      // );
      switch (prodCode) {
        case "S001":
          router.push(`/answerDetails/${store.state.perm}?id=${id}`);
          break;
        case "S002":
          router.push(`/PaperParse?id=${id}`);
          break;
        default:
          break;
      }
    };
    const isBeike = computed(() => {
      return store.getters.isBeike;
    });
    // 跳转试卷解析
    // 查询复核报告是否存在
    onMounted(() => {
      // 获取科目总成绩
      getSubjectAllScore();
      getProductsList();
    });
    onBeforeUnmount(() => {
      toast.value?.clear();
    });
    return {
      productClick,
      informationList,
      bgImageStatus,
      informationObj,
      name,
      scoreObj,
      detailOpenTime,
      classAdd,
      productList,
      isBeike,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/color.scss";
@import "scss/base.scss";
.container {
  width: 100%;
  overflow: hidden;
  height: 100%;
  .cards {
    margin-top: -7%;
  }
  .card-scroll {
    // overflow: scroll;
    .button-container {
      display: flex;
      width: 75%;
      margin: 0 auto;
      margin-top: 18%;
      justify-content: center;
      column-gap: 10px;
      &.buttonAdd {
        margin-top: 3%;
      }
      .question-detail {
        @include flex-center;
        padding: 0 30px;
        height: 80px;
        color: #fff;
        background-color: var(--primary-color);
        border-radius: 40px;
        font-size: 30px;
        &.disabled {
          background-color: #ccc;
          cursor: not-allowed;
          // pointer-events: none;
        }
      }
    }
  }
  .bottom {
    padding: 24px;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0;
    color: $color-gray;
    line-height: 40px;
    font-size: 28px;
  }
}
</style>
